import * as React from 'react';

function SvgIconNo(props) {
  return (
    <svg width={13} height={13} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6.5 4.53L10.623.408a1.393 1.393 0 011.97 1.97L8.47 6.5l4.122 4.122a1.394 1.394 0 01-1.97 1.97L6.5 8.47l-4.123 4.122a1.393 1.393 0 01-1.97-1.97L4.53 6.5.408 2.378a1.394 1.394 0 011.97-1.97L6.5 4.53z" />
    </svg>
  );
}

export default SvgIconNo;
